export default "__VITE_ASSET__D_cp3HUz__"